export default __webpack_public_path__ + "static/media/RC_header_scan.62b14184.gif";